var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',_vm._b({class:['b-icon', _vm.name, _vm.size, _vm.color]},'i',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }